import * as React from "react";
import Svg, { Path } from "react-native-svg";

const MicrophoneIcon = (props) => (
  <Svg
    width={32}
    height={32}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Path
      d="M8 17s0 7 8 7 8-7 8-7M13 29h6m-3-5v5m0-27c-4 0-4 4-4 4v10s0 4 4 4 4-4 4-4V6s0-4-4-4Z"
      stroke={props.color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Svg>
);
MicrophoneIcon.defaultProps = {
  color: "#888",
};
export default MicrophoneIcon;
